import { useState } from 'react';
import {
    notification,
    Switch,
    Typography,
} from 'antd';
import { editWorkspace } from '../../../../api/workspaces';

interface Props {
    workspaceId: string;
    hasModularPlan: boolean;
}

const { Text } = Typography;

const ModularWorkspaceSelector = ({ workspaceId, hasModularPlan }: Props) => {
    const [hasModularPlanState, setHasModularPlanState] = useState(hasModularPlan);
    const [loading, setLoading] = useState(false);

    const handlePlanChange = async (newValue: boolean) => {
        try {
            setLoading(true);
            const result = await editWorkspace(workspaceId, { hasModularPlan: newValue });
            notification.success({ message: result.data.message });
            setHasModularPlanState(newValue);
        } catch (error) {
            console.log(error);
            notification.error({ message: 'oops! An error has occurred' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Switch
            checked={hasModularPlanState}
            onChange={handlePlanChange}
            loading={loading}
        />
    );
};

export default ModularWorkspaceSelector;
